import React from 'react';
interface SupportTypeSelectorProps {
  selectedType: 'round' | 'square';
  onTypeChange: (type: 'round' | 'square') => void;
}
export function SupportTypeSelector({
  selectedType,
  onTypeChange
}: SupportTypeSelectorProps) {
  const supportTypes = [{
    value: 'round' as const,
    label: 'Support Rond'
  }, {
    value: 'square' as const,
    label: 'Support Carré'
  }];
  return <div className="rounded-xl border-2 bg-white p-6 shadow-sm transition-shadow hover:shadow-md" style={{
    borderColor: '#E5E7EB'
  }} data-id="element-73">
      <label className="mb-3 block text-sm font-bold uppercase tracking-wide" style={{
      color: '#6B4423'
    }} data-id="element-74">
        Type de support
      </label>
      <select value={selectedType} onChange={e => onTypeChange(e.target.value as 'round' | 'square')} className="w-full rounded-lg border-2 p-3 text-sm font-medium transition-all focus:outline-none focus:ring-2" style={{
      borderColor: '#D1D5DB',
      color: '#000000'
    }} onFocus={e => {
      e.target.style.borderColor = '#6B4423';
      e.target.style.boxShadow = '0 0 0 3px rgba(107, 68, 35, 0.1)';
    }} onBlur={e => {
      e.target.style.borderColor = '#D1D5DB';
      e.target.style.boxShadow = 'none';
    }} data-id="element-75">
        {supportTypes.map(type => <option key={type.value} value={type.value} data-id="element-76">
            {type.label}
          </option>)}
      </select>
    </div>;
}